import { StreamingPacing } from './StreamingPacing';
import { PLATFORM_DISPLAY, PLATFORM_STREAMING } from './streaming-pacing-types';

export const StreamingPacingPage = () => <StreamingPacing platform={PLATFORM_STREAMING} />;
export const DisplayPacingPage = () => <StreamingPacing platform={PLATFORM_DISPLAY} />;
